import React, { useEffect, useState } from "react";
import { Popconfirm, Spin, Table } from "antd";
import { NotePencil } from "../../../../svg/NotePencil";
import { Garbage } from "../../../../svg/Garbage";
import CreateAndEditModal from "./CreateAndEditModal";
import { isOpenSettingEditModal } from "../../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { useExpense } from "../../../../queries/queries";
import { LoadingOutlined } from "@ant-design/icons";
import { useDeleteExpense } from "../../../../queries/mutations";
import PaginationComp from "../../universialComponents/PaginationComp";
import { RootState } from "../../../../redux/rootReducer";

const { Column } = Table;

const Expense = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteId, setDeleteId] = useState(0);
  const [editedId, setEditedId] = useState(0);

  const dispatch = useDispatch();
  const searchString = useSelector(
    (state: RootState) => state.searchHeader.searchString
  );

  const { isLoading, data, isFetching } = useExpense(
    currentPage,
    searchString,
    false
  );
  const deleteExpense = useDeleteExpense(setDeleteId, currentPage);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchString]);

  const deleteFunc = async (id: number) => {
    try {
      setDeleteId(id);
      await deleteExpense.mutateAsync(id);
      if (data?.data.length === 1 && data.current_page !== 1)
        setCurrentPage(currentPage - 1);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <Table
        loading={isLoading}
        pagination={false}
        rowKey={(record) => record.id!}
        dataSource={data?.data || []}
      >
        <Column
          key={"key"}
          width={"10%"}
          title={"#"}
          align={"center"}
          render={(record, i, index) => (
            <span>{(currentPage - 1) * 10 + index + 1}</span>
          )}
        />
        <Column
          key={"name"}
          title={
            <>
              <span style={{ marginRight: "1rem" }}>NOMI</span>
              {isFetching && <LoadingOutlined />}
            </>
          }
          dataIndex={"name"}
        />
        <Column
          key="category_name"
          title="Kategoriya nomi"
          dataIndex="category_name"
        />
        <Column
          key={"action"}
          width={"10%"}
          title={"ACTION"}
          align={"center"}
          render={(record) => (
            <div>
              <span title={"O'zgartirish"}>
                <NotePencil
                  onClick={() => {
                    setEditedId(record.id);
                    dispatch(isOpenSettingEditModal(true));
                  }}
                  className={"tableIcon"}
                />
              </span>
              {deleteExpense.isLoading && deleteId === record.id ? (
                <Spin />
              ) : (
                <Popconfirm
                  placement="left"
                  title="O'chirshni xohlaysizmi?"
                  onConfirm={() => deleteFunc(record.id)}
                  okText="Xa"
                  cancelText="Yoq"
                >
                  <span title={"O'chirish"}>
                    <Garbage className={"tableIcon"} />
                  </span>
                </Popconfirm>
              )}
            </div>
          )}
        />
      </Table>
      <CreateAndEditModal
        page={currentPage}
        currentExpenseId={editedId}
        setCurrentId={setEditedId}
      />
      <PaginationComp
        paginationProps={{
          total: data?.total,
          current: data?.current_page,
          pageSize: data?.per_page || 10,
          onChange: (page) => {
            setCurrentPage(page);
          },
        }}
      />
    </>
  );
};

export default Expense;
